import { resolveDynamicSchema as e, useDynamicScope as t } from "./helpers/dynamic-scope.js";
import { getRefName as n } from "./helpers/get-ref-name.js";
import { hasComplexArrayItems as ee } from "./helpers/has-complex-array-items.js";
import { unwrapForRead as r } from "./helpers/unwrap-for-read.js";
import { getCompositionsToRender as te, inferDiscriminatorMappingComposition as i } from "./helpers/get-compositions-to-render.js";
import { isTypeObject as a } from "./helpers/is-type-object.js";
import { partitionAllOfCompositions as ne } from "./helpers/partition-all-of-compositions.js";
import { SCHEMA_ANCESTORS_SYMBOL as re, getCycleKey as ie } from "./helpers/schema-cycle.js";
import { toNodeKey as ae, useSchemaExpansion as oe } from "./helpers/schema-expansion.js";
import { useLocalization as se } from "./localization/index.js";
import ce from "./SchemaRailPanel.vue.js";
import le from "./SchemaComposition.vue.js";
import { sortPropertyNames as ue } from "./helpers/sort-property-names.js";
import de from "./components/CopyLinkButton.vue.js";
import fe from "./components/WithBreadcrumb.vue.js";
import { getEnumValues as pe } from "./helpers/get-enum-values.js";
import { getPropertyDescription as me } from "./helpers/get-property-description.js";
import { typeSignatureInlinesEnum as he } from "./helpers/get-type-signature-tokens.js";
import { normalizeObjectComposition as ge } from "./helpers/normalize-object-composition.js";
import { optimizeValueForDisplay as o } from "./helpers/optimize-value-for-display.js";
import { shouldDisplayDescription as _e } from "./helpers/should-display-description.js";
import { shouldDisplayHeading as ve } from "./helpers/should-display-heading.js";
import ye from "./SchemaCollapsedPreview.vue.js";
import be from "./SchemaEnums.vue.js";
import xe from "./SchemaGutterToggle.vue.js";
import Se from "./SchemaPropertyHeading.vue.js";
import Ce from "./Schema.vue.js";
import { Fragment as we, computed as s, createBlock as c, createCommentVNode as l, createElementBlock as u, createElementVNode as Te, createSlots as Ee, createTextVNode as De, createVNode as d, defineComponent as f, inject as Oe, mergeProps as p, normalizeClass as ke, onBeforeUnmount as Ae, onScopeDispose as je, openBlock as m, ref as Me, renderList as Ne, resolveDynamicComponent as h, toDisplayString as Pe, toHandlers as Fe, toRef as Ie, unref as g, useId as _, useTemplateRef as v, watch as y, withCtx as b } from "vue";
import { ScalarMarkdown as Le } from "@scalar/components/markdown";
import { isDynamicRef as Re, resolveDynamicRef as ze } from "@scalar/workspace-store/helpers/dynamic-ref";
import { resolve as x } from "@scalar/workspace-store/resolve";
import { isArraySchema as S } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
import { ScalarWrappingText as C } from "@scalar/components/wrapping-text";
//#region src/schema/SchemaProperty.vue?vue&type=script&setup=true&lang.ts
var Be = ["id"], Ve = {
	key: 0,
	class: "property-name-pattern-properties text-c-1! border-0! p-0! before:hidden!"
}, He = {
	key: 1,
	class: "property-name-additional-properties text-c-1! border-0! p-0! before:hidden!"
}, Ue = ["id"], We = {
	key: 0,
	class: "property-name-pattern-properties text-c-1! border-0! p-0! before:hidden!"
}, Ge = {
	key: 1,
	class: "property-name-additional-properties text-c-1! border-0! p-0! before:hidden!"
}, Ke = {
	key: 2,
	class: "property-description mt-1! has-[+.property-rule]:mb-1.5!"
}, qe = ["id"], Je = {
	key: 7,
	class: "children [.property-description+&]:mt-1.5!"
}, Ye = Object.freeze({}), w = /*@__PURE__*/ f({
	__name: "SchemaProperty",
	props: {
		is: {},
		schema: {},
		extensionSource: {},
		noncollapsible: { type: Boolean },
		level: { default: 0 },
		depth: { default: 0 },
		name: {},
		required: {
			type: Boolean,
			default: !1
		},
		compact: {
			type: Boolean,
			default: !1
		},
		discriminator: {},
		description: {},
		hideModelNames: {
			type: Boolean,
			default: !1
		},
		hideHeading: { type: Boolean },
		modelName: {},
		variant: {},
		breadcrumb: {},
		eventBus: {},
		options: {},
		propertyNamesEnum: {},
		propertyNamesSchema: {},
		schemaContext: {},
		compositionPath: {},
		compositionPathSegment: {},
		cycleKey: {},
		scrollTargetId: {},
		specificationExtension: {},
		expansion: {}
	},
	setup(f) {
		let w = f, Xe = [
			"oneOf",
			"anyOf",
			"allOf"
		], T = t(), E = s(() => ge(o(e(r(w.schema), T)), w.name)), D = s(() => {
			let { name: e } = w, t = E.value;
			return !!e && !!t?.allOf && ne(t).segments.some((e) => e.kind === "object" && a(e.schema));
		}), O = s(() => w.breadcrumb ? w.name ? [...w.breadcrumb, w.name] : w.breadcrumb : void 0), k = s(() => w.compositionPathSegment ? [...w.compositionPath ?? [], w.compositionPathSegment] : w.compositionPath ?? []), Ze = s(() => [...k.value, "items"]), Qe = s(() => {
			let e = w.options.linkablePropertyPath, t = O.value;
			return w.level <= 2 || !!(e && t && e.length === t.length && e.every((e, n) => e === t[n]));
		}), $e = s(() => Qe.value && (O.value?.length ?? 0) > 0), et = s(() => {
			let e = E.value;
			if (!e || !S(e) || !Re(e.items)) return e;
			let t = ze(e.items.$dynamicRef, T);
			return t ? {
				...e,
				items: t
			} : e;
		}), tt = s(() => ee(et.value)), nt = s(() => at.value.length > 0), rt = s(() => E.value ? i(E.value, w.options.document) : null), it = s(() => {
			let e = E.value;
			if (!e || !("properties" in e || "additionalProperties" in e) || "allOf" in e || !(w.schema && typeof w.schema == "object" && "allOf" in w.schema) && rt.value) return !1;
			let t = "type" in e ? e.type : void 0, n = typeof t == "string" && t !== "object";
			return a(e) || !n;
		}), A = s(() => {
			let e = E.value;
			return !e || !S(e) || e.items === void 0 ? !1 : tt.value;
		}), at = s(() => pe(E.value)), ot = s(() => me(E.value)), j = s(() => _e(E.value, w.description)), st = s(() => {
			let e = E.value;
			if (!e) return e;
			let { oneOf: t, anyOf: n, allOf: ee, not: r, discriminator: te, ...i } = e;
			if (j.value && "description" in i) {
				let { description: e, ...t } = i;
				return t;
			}
			return i;
		}), M = s(() => ve(E.value, w.name, w.required)), ct = s(() => B.value || D.value ? [] : te(E.value, w.options.document, rt.value)), lt = s(() => w.extensionSource ? {
			...w.extensionSource,
			...E.value
		} : E.value), ut = s(() => {
			let e = lt.value;
			if (!e || typeof e != "object") return !1;
			for (let t in e) if (t.startsWith("x-")) return !0;
			return !1;
		}), dt = (e) => e === "allOf" ? w.schema?.discriminator ?? w.discriminator : w.schema?.discriminator, N = s(() => {
			let e = et.value;
			if (!e || !S(e) || e.items === void 0) return;
			let t = x.schema(e.items);
			return Xe.some((e) => Array.isArray(t?.[e]) && t[e]?.length === 1) ? o(t) : t;
		}), ft = s(() => {
			let e = E.value;
			if (!(!e || !S(e))) return ie(e.items);
		}), P = s(() => ({
			compact: w.compact,
			eventBus: w.eventBus,
			hideModelNames: L.value,
			level: w.level + 1,
			name: w.name,
			options: w.options,
			schemaContext: w.schemaContext
		})), pt = s(() => it.value ? {
			...P.value,
			breadcrumb: O.value,
			compositionPath: k.value,
			cycleKey: w.cycleKey,
			schema: st.value
		} : null), mt = s(() => A.value && N.value ? {
			...P.value,
			compositionPath: Ze.value,
			cycleKey: ft.value,
			schema: x.schema(N.value)
		} : null), F = s(() => {
			let { cycleKey: e } = w;
			return D.value ? {
				...P.value,
				breadcrumb: O.value,
				compositionPath: k.value,
				cycleKey: e,
				schema: E.value
			} : pt.value ?? mt.value;
		}), ht = s(() => !pt.value && !!mt.value), gt = s(() => !!(w.name && w.discriminator?.propertyName === w.name)), { translate: I } = se(), L = s(() => w.hideModelNames || !!w.options.hideModelNames), R = s(() => D.value || it.value || A.value), _t = Oe(re, void 0), z = s(() => ht.value ? ft.value : w.cycleKey), B = s(() => z.value != null && !!_t?.has(z.value)), vt = s(() => {
			let e = z.value;
			if (typeof e == "string") {
				let t = n(e);
				if (t) return t;
			}
			return w.modelName || w.name || I("schema.schema");
		}), V = w.expansion ?? oe(Ie(() => w.scrollTargetId ?? "")), yt = _(), H = s(() => ae(O.value) || `~anonymous-${yt}`), U = s(() => R.value && !w.noncollapsible && M.value && !B.value), W = s(() => R.value && !!w.noncollapsible && !!w.name && M.value && !B.value), G = s(() => U.value && V.isExpanded(H.value, {
			cyclic: B.value,
			defaultOpen: !!w.options.expandAllSchemaProperties
		})), K = Me(!1);
		y(G, (e, t) => {
			if (e) {
				K.value &&= (V.untilFound.release(), !1);
				return;
			}
			t && (K.value = bt() && V.untilFound.acquire());
		}), je(() => {
			K.value &&= (V.untilFound.release(), !1);
		});
		let bt = () => typeof document < "u" && "onbeforematch" in document.body, xt = s(() => W.value || U.value && (G.value || K.value)), St = s(() => W.value || G.value ? void 0 : "until-found"), Ct = s(() => R.value && !B.value && !U.value && !W.value), wt = _(), q = _(), Tt = _(), Et = v("treePanel"), J = v("treeToggle"), Y = null, X = () => {
			Y?.removeAttribute("data-heading-hovered"), Y = null;
		}, Dt = {
			pointerenter: (e) => {
				X();
				let t = e.currentTarget instanceof HTMLElement ? e.currentTarget.parentElement : null;
				t && (t.setAttribute("data-heading-hovered", ""), Y = t);
			},
			pointerleave: X
		};
		y(U, (e) => {
			e || X();
		}), Ae(X), y(G, (e) => {
			if (e) return;
			let t = Et.value?.$el;
			t?.removeAttribute("data-rail-hovered"), t?.parentElement?.removeAttribute("data-child-rail-hovered");
		});
		let Z = s(() => ht.value ? N.value : st.value), Ot = s(() => Z.value ? ue(Z.value, void 0, w.options) : []), Q = s(() => {
			if (!R.value) return null;
			let e = Z.value;
			if (!e) return null;
			let t = w.options.hideReadOnly || w.options.hideWriteOnly ? Ot.value.length : a(e) && e.properties ? Object.keys(e.properties).length : 0, n = "patternProperties" in e && e.patternProperties ? Object.keys(e.patternProperties).length : 0, ee = "additionalProperties" in e && e.additionalProperties ? 1 : 0, r = t + n + ee;
			return r === 0 ? null : I("schema.propertyCount", { count: String(r) });
		}), kt = s(() => he(E.value, { hideModelNames: L.value })), At = s(() => w.modelName || I("schema.schema")), $ = () => {
			let e = !G.value;
			if (!e) {
				let e = document.activeElement, t = J.value instanceof HTMLElement ? J.value : J.value?.$el;
				e && Et.value?.$el.contains(e) && t?.focus();
			}
			V.setExpanded(H.value, e);
		}, jt = (e) => {
			if (!U.value) return;
			let t = e.target;
			t instanceof Element && t.closest("a, button, [role=\"button\"], input, select, label") || window.getSelection()?.toString() || $();
		}, Mt = () => {
			V.setExpanded(H.value, !0);
		};
		return (e, t) => (m(), c(h(f.is ?? "li"), { class: ke(["property", [
			`property--level-${f.level}`,
			{
				"property--compact": f.compact,
				"property--deprecated": E.value?.deprecated
			},
			"property--tree grid! grid-cols-[minmax(0,1fr)] border-b-0! px-0! py-[var(--schema-row-pad,6px)]!",
			{ "property--tree-container": !U.value && !B.value && (R.value || !M.value) },
			`property--depth-${f.depth}`
		]]) }, {
			default: b(() => [
				U.value ? (m(), c(xe, {
					key: 0,
					ref: "treeToggle",
					class: "absolute start-[calc(0px_-_var(--schema-toggle-half,12px)_-_var(--schema-gutter,16px))] top-2.5 z-[1] col-start-1 row-start-1 -translate-y-1/2 print:hidden",
					countId: Q.value ? g(Tt) : void 0,
					fallbackLabel: At.value,
					nameId: f.name ? g(q) : void 0,
					open: G.value,
					panelId: g(wt),
					panelRendered: xt.value,
					onToggle: $
				}, null, 8, [
					"countId",
					"fallbackLabel",
					"nameId",
					"open",
					"panelId",
					"panelRendered"
				])) : l("", !0),
				M.value ? (m(), c(Se, p({
					key: 1,
					class: ["group", [{ "cursor-pointer": U.value }, "relative row-start-1 min-h-5 content-center [&>*:has(+.copy-link-trailing)]:me-0!"]],
					enum: nt.value,
					eventBus: f.eventBus,
					hideModelNames: L.value,
					isDiscriminator: gt.value,
					keyKind: f.variant === "additionalProperties" ? "additional" : f.variant === "patternProperties" ? "pattern" : void 0,
					modelLinkOptions: {
						hideModels: f.options.hideModels,
						document: f.options.document
					},
					modelName: f.modelName,
					propertyNames: f.propertyNamesSchema,
					recursiveTo: B.value ? vt.value : void 0,
					required: f.required,
					value: E.value
				}, Fe(U.value ? Dt : g(Ye)), { onClick: jt }), Ee({ _: 2 }, [
					f.name ? {
						name: "name",
						fn: b(() => [$e.value ? (m(), c(fe, {
							key: 0,
							breadcrumb: O.value
						}, {
							default: b(() => [Te("span", { id: g(q) }, [f.variant === "patternProperties" ? (m(), u("span", Ve, [d(g(C), {
								preset: "property",
								text: f.name
							}, null, 8, ["text"])])) : f.variant === "additionalProperties" ? (m(), u("span", He, [d(g(C), {
								preset: "property",
								text: f.name
							}, null, 8, ["text"])])) : (m(), c(g(C), {
								key: 2,
								preset: "property",
								text: f.name
							}, null, 8, ["text"]))], 8, Be)]),
							_: 1
						}, 8, ["breadcrumb"])) : (m(), u("span", {
							key: 1,
							id: g(q)
						}, [f.variant === "patternProperties" ? (m(), u("span", We, [d(g(C), {
							preset: "property",
							text: f.name
						}, null, 8, ["text"])])) : f.variant === "additionalProperties" ? (m(), u("span", Ge, [d(g(C), {
							preset: "property",
							text: f.name
						}, null, 8, ["text"])])) : (m(), c(g(C), {
							key: 2,
							preset: "property",
							text: f.name
						}, null, 8, ["text"]))], 8, Ue))]),
						key: "0"
					} : void 0,
					E.value?.example === void 0 ? void 0 : {
						name: "example",
						fn: b(() => [De(" Example: " + Pe(E.value.example), 1)]),
						key: "1"
					},
					U.value && !G.value ? {
						name: "preview",
						fn: b(() => [d(ye, {
							"aria-hidden": "true",
							class: "mr-0!",
							propertyNames: Ot.value,
							schema: Z.value
						}, null, 8, ["propertyNames", "schema"])]),
						key: "2"
					} : void 0,
					f.name && Qe.value && O.value ? {
						name: "trailing",
						fn: b(() => [d(de, {
							anchorId: O.value.join("."),
							eventBus: f.eventBus
						}, null, 8, ["anchorId", "eventBus"])]),
						key: "3"
					} : void 0
				]), 1040, [
					"class",
					"enum",
					"eventBus",
					"hideModelNames",
					"isDiscriminator",
					"keyKind",
					"modelLinkOptions",
					"modelName",
					"propertyNames",
					"recursiveTo",
					"required",
					"value"
				])) : l("", !0),
				j.value || ot.value ? (m(), u("div", Ke, [d(g(Le), { value: j.value || ot.value || "" }, null, 8, ["value"])])) : l("", !0),
				f.propertyNamesEnum && f.propertyNamesEnum.length > 0 ? (m(), c(be, {
					key: 3,
					propertyNames: "",
					value: { enum: f.propertyNamesEnum }
				}, null, 8, ["value"])) : l("", !0),
				at.value.length > 0 && !A.value && !kt.value ? (m(), c(be, {
					key: 4,
					value: E.value
				}, null, 8, ["value"])) : l("", !0),
				U.value && Q.value ? (m(), u("span", {
					key: 5,
					id: g(Tt),
					class: "screenreader-only"
				}, Pe(Q.value), 9, qe)) : l("", !0),
				xt.value ? (m(), c(ce, {
					key: 6,
					id: g(wt),
					ref: "treePanel",
					class: "property-children mt-1.5 mb-0.5 [&_.schema-card]:mb-0! [&_.schema-card]:pb-0! [&_.schema-properties]:mb-0! [&_.schema-properties]:pb-0! [&_ul]:my-0! [&_ul]:py-0! [&[hidden=until-found]]:my-0 [&[hidden=until-found]]:border-s-0 [&[hidden]:not([hidden=until-found])]:hidden",
					closeOnRail: U.value,
					depth: f.depth + 1,
					hidden: St.value,
					onBeforematch: Mt,
					onClose: $
				}, {
					default: b(() => [F.value ? (m(), c(Ce, p({ key: 0 }, F.value, {
						depth: f.depth + 1,
						expansion: g(V),
						noncollapsible: "",
						scrollTargetId: f.scrollTargetId,
						specificationExtension: f.specificationExtension
					}), null, 16, [
						"depth",
						"expansion",
						"scrollTargetId",
						"specificationExtension"
					])) : l("", !0)]),
					_: 1
				}, 8, [
					"id",
					"closeOnRail",
					"depth",
					"hidden"
				])) : l("", !0),
				Ct.value ? (m(), u("div", Je, [F.value ? (m(), c(Ce, p({ key: 0 }, F.value, {
					depth: f.depth,
					expansion: g(V),
					noncollapsible: "",
					scrollTargetId: f.scrollTargetId,
					specificationExtension: f.specificationExtension
				}), null, 16, [
					"depth",
					"expansion",
					"scrollTargetId",
					"specificationExtension"
				])) : l("", !0)])) : l("", !0),
				(m(!0), u(we, null, Ne(ct.value, (e) => (m(), c(le, {
					key: e.composition,
					breadcrumb: O.value,
					compact: f.compact,
					composition: e.composition,
					compositionPath: k.value,
					depth: f.depth,
					discriminator: dt(e.composition),
					eventBus: f.eventBus,
					expansion: g(V),
					hideHeading: f.hideHeading,
					hideModelNames: L.value,
					level: f.level,
					name: f.name,
					noncollapsible: f.noncollapsible,
					options: f.options,
					schema: e.value,
					schemaContext: f.schemaContext,
					scrollTargetId: f.scrollTargetId,
					specificationExtension: f.specificationExtension
				}, null, 8, [
					"breadcrumb",
					"compact",
					"composition",
					"compositionPath",
					"depth",
					"discriminator",
					"eventBus",
					"expansion",
					"hideHeading",
					"hideModelNames",
					"level",
					"name",
					"noncollapsible",
					"options",
					"schema",
					"schemaContext",
					"scrollTargetId",
					"specificationExtension"
				]))), 128)),
				ut.value && f.specificationExtension ? (m(), c(h(f.specificationExtension), {
					key: 8,
					showExtensions: f.options.showExtensions,
					value: lt.value
				}, null, 8, ["showExtensions", "value"])) : l("", !0)
			]),
			_: 1
		}, 8, ["class"]));
	}
});
//#endregion
export { w as default };

//# sourceMappingURL=SchemaProperty.vue.script.js.map